module.exports = __webpack_public_path__ + "img/south-korea-flag.af5e3a8c.png";